'use es6';

import { createSelector } from 'reselect';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { createContentModelSelector, getContentModel } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { RSS_STATUS_TYPES, VALID_RSS_STATUS_TYPES } from 'EmailEditorUI/lib/ReviewUtils';
import I18n from 'I18n';
import { getIsBlogEmail, getIsBlogOrRssEmail } from 'EmailEditorUI/redux/selectors/EmailSelectors';
import { getRssFeedUrlValidationResult } from 'EmailData/selectors/rssFeedUrlValidationSelectors';
import { getIsDragDropEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { getIsBlogRssModule } from 'EmailEditorUI/utils/moduleUtils';
import { getModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
const getBlogs = basicSelector(state => state.blogs);
const rssValues = ['blogRssSettings', 'rssEmailCommentText', 'maxRssEntries', 'rssEmailEntryTemplate', 'rssEmailAuthorLineTemplate', 'rssEmailByText', 'rssEmailEntryLayoutDefault', 'rssEmailBlogImageMaxWidth', 'rssEmailImageMaxWidth', 'rssEmailByTextDefault', 'rssEmailClickThroughText', 'rssToEmailTiming', 'rssUrl', 'rssEmailEntryTemplateDefault', 'rssEmailEntryTemplateEnabled'];
export const getRssData = createSelector([getContentModel], contentModel => {
  const rssData = {};
  rssValues.forEach(property => {
    rssData[property] = contentModel[property];
  });
  return rssData;
});
export const getBlogSubscriptionId = createContentModelSelector('subscriptionBlogId');
export const getBlogForEmail = createSelector([getBlogSubscriptionId, getBlogs], (blogId, blogs) => blogId && blogs[blogId]);
export const getBlogEmailType = createContentModelSelector('blogEmailType');
export const getUseRssHeadlineAsSubject = createContentModelSelector('useRssHeadlineAsSubject');
const rssFormFieldSelector = prop => createSelector([getRssData, getIsBlogOrRssEmail], (rssData, isRssEmail) => isRssEmail && rssData[prop]);
export const getRssUrl = rssFormFieldSelector('rssUrl');
export const getRssFrequencyData = rssFormFieldSelector('rssToEmailTiming');
export const getRssTimeInMinutes = createSelector([getRssFrequencyData], data => {
  if (!data || !data.time) {
    return null;
  }
  const moment = I18n.moment(data.time, 'H:mm A', 'en');
  const mmtMidnight = moment.clone().startOf('day');
  return moment.diff(mmtMidnight, 'minutes');
});
export const getRssValidationErrors = createSelector([getRssData, getRssFeedUrlValidationResult, getIsBlogEmail, getIsBlogOrRssEmail, getModules, getIsDragDropEmail], (rssData, validationResult, isBlogEmail, isRssEmail, modules, isDragDrop) => {
  if (!isRssEmail) {
    return {};
  }
  const frequencyData = rssData.rssToEmailTiming;
  const rssUrl = rssData.rssUrl;
  const repeats = frequencyData.repeats;
  const time = frequencyData.time;
  const errors = {};

  //repeats
  if (!repeats) {
    errors['repeats'] = {
      type: 'required',
      pane: 'send'
    };
  }
  if (isBlogEmail) {
    return errors;
  }
  if (repeats === 'monthly' && !(frequencyData !== null && frequencyData !== void 0 && frequencyData.repeats_on_monthly)) {
    errors['repeats_on_monthly'] = {
      type: 'required',
      pane: 'send'
    };
  }
  if (repeats === 'weekly' && typeof (frequencyData === null || frequencyData === void 0 ? void 0 : frequencyData.repeats_on_weekly) !== 'number') {
    errors['repeats_on_weekly'] = {
      type: 'required',
      pane: 'send'
    };
  }
  if (!time) {
    errors['time'] = {
      type: 'required',
      pane: 'send'
    };
  } else if (!I18n.moment(time, 'H:mm a', 'en', true).isValid()) {
    errors['time'] = {
      type: 'invalid',
      pane: 'send',
      translated: true,
      message: I18n.text('rssScheduling.time.errors.invalid')
    };
  }
  const status = rssUrl ? validationResult.get('feedResultStatus') : 'REQUIRED';
  if (status && !VALID_RSS_STATUS_TYPES.includes(status) && status !== RSS_STATUS_TYPES.TIMEOUT) {
    const extraParams = {};
    if (isDragDrop) {
      const blogRssWidget = Object.values(modules).find(getIsBlogRssModule);
      if (blogRssWidget) {
        extraParams.widgetId = blogRssWidget.get('id');
      }
    }
    errors['rssUrl'] = Object.assign({
      type: 'rss_url',
      status: status.toLowerCase(),
      pane: 'content',
      translated: true,
      message: I18n.text(`rssFeed.items.rssUrl.status.errors.${status.toLowerCase()}`)
    }, extraParams);
  }
  return errors;
});